/**
 * Brera · Colecciones, diseño "Lista con foto al lado" (sections/collection-list.liquid, mode == 'list')
 * Al pasar el mouse (o con el foco) por un nombre: ese nombre queda activo, cambia la foto y, si el bloque
 * tiene "Color de fondo", cambia el fondo de la sección (--cl-spot-bg).
 * En pantallas táctiles el primer toque elige el nombre y el segundo abre la colección.
 * En el editor muestra la colección seleccionada.
 */
(() => {
  if (window.BreraCollectionList) return;

  const initList = (list) => {
    if (list.dataset.ready) return;
    list.dataset.ready = '1';
    const section = list.closest('.cl-section');
    const links = [...list.querySelectorAll('.cl-spot__link')];
    const images = [...list.querySelectorAll('.cl-spot__image')];
    const baseBg = section ? section.style.getPropertyValue('--cl-spot-bg') : '';
    const canHover = window.matchMedia('(hover: hover)');

    const activate = (i) => {
      const index = String(i);
      links.forEach((a) => a.classList.toggle('is-active', a.dataset.index === index));
      images.forEach((el) => el.classList.toggle('is-active', el.dataset.index === index));
      const link = links.find((a) => a.dataset.index === index);
      if (!section || !link) return;
      if (link.dataset.bg) section.style.setProperty('--cl-spot-bg', link.dataset.bg);
      else if (baseBg) section.style.setProperty('--cl-spot-bg', baseBg);
      else section.style.removeProperty('--cl-spot-bg');
    };

    links.forEach((a) => {
      a.addEventListener('mouseenter', () => activate(a.dataset.index));
      a.addEventListener('focus', () => activate(a.dataset.index));
      a.addEventListener('click', (e) => {
        if (canHover.matches || a.classList.contains('is-active')) return;
        e.preventDefault();
        activate(a.dataset.index);
      });
    });

    list.activate = activate;
  };

  const init = (scope) => scope.querySelectorAll('[data-cl-list]').forEach(initList);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);

  // Editor del tema
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const list = e.target.closest && e.target.closest('[data-cl-list]');
    if (!list || !list.activate) return;
    const link = e.target.querySelector('.cl-spot__link');
    if (link) list.activate(link.dataset.index);
  });

  window.BreraCollectionList = { init };
})();
